const isObject = (value: unknown): value is Record<string, unknown> => {
  return (
    value != null &&
    (value.constructor === Object ||
      (!value.constructor && typeof value === "object"))
  );
};

export const deepTrimValue = (value: unknown): any => {
  if (typeof value === "string") {
    return value.trim();
  }
  if (typeof value === "number" && isNaN(value)) {
    return null;
  }
  if (Array.isArray(value)) {
    return value.map(deepTrimValue);
  }
  if (typeof value === "function") {
    return value;
  }
  if (isObject(value)) {
    return Object.keys(value).reduce<typeof value>((acc, key) => {
      acc[key] = deepTrimValue(value[key]);
      return acc;
    }, {});
  }

  return value;
};
